export function PermissionIcon({
  className = "w-[15px] h-[19px]",
}: {
  className?: string;
}) {
  return (
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M6.91857 17.1224C7.10306 17.23 7.1953 17.2838 7.32549 17.3118C7.42652 17.3334 7.57393 17.3334 7.67496 17.3118C7.80514 17.2838 7.89739 17.23 8.08188 17.1224C9.70526 16.1753 14.1669 13.2004 14.1669 9.11V5.12467C14.1669 4.45841 14.1669 4.12528 14.0579 3.83892C13.9617 3.58595 13.8052 3.36023 13.6022 3.18127C13.3723 2.9787 13.0604 2.86173 12.4366 2.62779L7.96839 0.952228C7.79514 0.887261 7.70852 0.854777 7.6194 0.8419C7.54036 0.830478 7.46009 0.830478 7.38104 0.8419C7.29193 0.854777 7.20531 0.887261 7.03206 0.952228L2.56389 2.62779C1.94006 2.86173 1.62814 2.9787 1.39827 3.18127C1.19521 3.36023 1.03879 3.58595 0.942524 3.83892C0.833557 4.12528 0.833557 4.45841 0.833557 5.12467V9.11C0.833557 13.2004 5.29519 16.1753 6.91857 17.1224Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "PermissionIcon";
